module.exports = __webpack_public_path__ + "img/CD.eb45d362.svg";